import type { CertStatus } from '@/components/ui/StatusBadge';

export interface Certificate {
  id: string;
  name: string;
  certNumber: string;
  issuingAuthority: string;
  issueDate: string;
  expiryDate: string;
  status: CertStatus;
  daysRemaining: number | null;
  category: 'STCW' | 'Medical' | 'Flag State' | 'Endorsement' | 'Proficiency';
  courseOnExpiry?: string;
  lifecycleType?: string;
  actionLabel?: string;
  requirementNote?: string;
  sourceRuleId?: string;
}

export const mockCertificates: Certificate[] = [
  {
    id: 'cert-001',
    name: 'Certificate of Competency — Chief Officer',
    certNumber: 'IND-CO-2021-04821',
    issuingAuthority: 'MMD Mumbai',
    issueDate: '12/03/2021',
    expiryDate: '11/03/2026',
    status: 'valid',
    daysRemaining: 303,
    category: 'Flag State',
  },
  {
    id: 'cert-002',
    name: 'Basic Safety Training (BST)',
    certNumber: 'BST-MUM-2022-18340',
    issuingAuthority: 'HIMT Chennai',
    issueDate: '05/07/2022',
    expiryDate: '04/07/2027',
    status: 'valid',
    daysRemaining: 784,
    category: 'STCW',
  },
  {
    id: 'cert-003',
    name: 'Medical Fitness Certificate (ENG1)',
    certNumber: 'ENG1-2024-MUM-09231',
    issuingAuthority: 'Dr. Kapoor Maritime Clinic',
    issueDate: '18/05/2024',
    expiryDate: '17/05/2026',
    status: 'expiring-soon',
    daysRemaining: 5,
    category: 'Medical',
    courseOnExpiry: 'Schedule ENG1 medical exam at an approved maritime clinic',
  },
  {
    id: 'cert-004',
    name: 'GMDSS — GOC',
    certNumber: 'GOC-IND-2019-00672',
    issuingAuthority: 'MMD Kolkata',
    issueDate: '22/08/2019',
    expiryDate: '21/08/2024',
    status: 'expired',
    daysRemaining: null,
    category: 'STCW',
    courseOnExpiry: 'GMDSS Refresher Course — 5 days, DG approved institute',
  },
  {
    id: 'cert-005',
    name: 'Proficiency in Survival Craft & Rescue Boats (PSCRB)',
    certNumber: 'PSCRB-2021-09104',
    issuingAuthority: 'NUSI Institute Mumbai',
    issueDate: '14/01/2021',
    expiryDate: '13/01/2026',
    status: 'expiring-soon',
    daysRemaining: 62,
    category: 'Proficiency',
    courseOnExpiry: 'PSCRB Refresher — 3 days at DG approved maritime institute',
  },
  {
    id: 'cert-006',
    name: 'Advanced Fire Fighting (AFF)',
    certNumber: 'AFF-MUM-2022-04411',
    issuingAuthority: 'TSMIT Navi Mumbai',
    issueDate: '30/03/2022',
    expiryDate: '29/03/2027',
    status: 'valid',
    daysRemaining: 686,
    category: 'STCW',
  },
  {
    id: 'cert-007',
    name: 'Medical First Aid (MFA)',
    certNumber: 'MFA-2022-KOL-00211',
    issuingAuthority: 'Calcutta Seamens Club',
    issueDate: '10/06/2022',
    expiryDate: '09/06/2027',
    status: 'valid',
    daysRemaining: 758,
    category: 'STCW',
  },
  {
    id: 'cert-008',
    name: 'Radar Navigation & ARPA Simulator',
    certNumber: 'RADAR-ARPA-2020-MUM-7721',
    issuingAuthority: 'IIMM Mumbai',
    issueDate: '19/02/2020',
    expiryDate: '18/02/2025',
    status: 'expired',
    daysRemaining: null,
    category: 'Endorsement',
    courseOnExpiry: 'Radar/ARPA refresher — 2 days, DG approved simulator',
  },
  {
    id: 'cert-009',
    name: 'Ship Security Officer (SSO)',
    certNumber: 'SSO-IND-2023-00934',
    issuingAuthority: 'MMD Mumbai',
    issueDate: '07/11/2023',
    expiryDate: '06/11/2028',
    status: 'valid',
    daysRemaining: 1274,
    category: 'Flag State',
  },
  {
    id: 'cert-010',
    name: 'Crowd Management & Crisis Training',
    certNumber: 'CM-2021-CHE-03312',
    issuingAuthority: 'HIMT Chennai',
    issueDate: '25/04/2021',
    expiryDate: '24/04/2026',
    status: 'critical',
    daysRemaining: 12,
    category: 'STCW',
    courseOnExpiry: 'Crowd Management refresher — 1 day, any DG approved institute',
  },
  {
    id: 'cert-011',
    name: 'High Voltage Electrical Safety',
    certNumber: 'HVES-2022-MUM-00451',
    issuingAuthority: 'TSMIT Navi Mumbai',
    issueDate: '14/09/2022',
    expiryDate: '13/09/2027',
    status: 'valid',
    daysRemaining: 854,
    category: 'Endorsement',
  },
  {
    id: 'cert-012',
    name: 'Continuous Discharge Certificate (CDC)',
    certNumber: 'CDC-MUM-2019-CO-04821',
    issuingAuthority: 'MMD Mumbai',
    issueDate: '03/01/2019',
    expiryDate: '02/01/2029',
    status: 'valid',
    daysRemaining: 1696,
    category: 'Flag State',
  },
];

export const certCategories = ['All', 'STCW', 'Medical', 'Flag State', 'Endorsement', 'Proficiency'] as const;
export type CertCategory = typeof certCategories[number];
